import { render, staticRenderFns } from "./rebate-number-formatter.vue?vue&type=template&id=b35d1ff0"
import script from "./rebate-number-formatter.vue?vue&type=script&lang=js"
export * from "./rebate-number-formatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports